import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Action from './Action';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';

class Actions extends React.PureComponent {
    onMultiUserAction = action => {
        const { onAction, selectedUsersIds } = this.props;
        onAction([...selectedUsersIds], action);
    };
    render() {
        const {
            actions,
            users,
            selectedUsersIds,
            onSelectAllClick,
            classes,
        } = this.props;
        if (!actions.length || users.length === 0) {
            return null;
        }

        let actionsList, selectedNo;
        if (selectedUsersIds.size !== 0) {
            actionsList = actions.map(action => (
                <Action
                    key={action}
                    action={action}
                    onClick={this.onMultiUserAction}
                />
            ));
            selectedNo = `(${selectedUsersIds.size} selected)`;
        }

        return (
            <div className={classes.wrapper}>
                <div className={classes.actions}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={users.length === selectedUsersIds.size}
                                onChange={onSelectAllClick}
                            />
                        }
                        label="Select all"
                    />
                    <Typography noWrap>{selectedNo}</Typography>
                </div>
                <div className={classes.actions}>{actionsList}</div>
            </div>
        );
    }
}

Actions.propTypes = {
    users: PropTypes.array.isRequired,
    actions: PropTypes.array,
    selectedUsersIds: PropTypes.object.isRequired,
    onAction: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
};

Actions.defaultProps = {
    actions: [],
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: spacing.unit * 3,
        paddingLeft: spacing.unit * 4,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
    },
});

export default injectSheet(style)(Actions);



// WEBPACK FOOTER //
// ./src/components/users/Actions.js